var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{staticClass:"check-container",model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},_vm._l((_vm.options),function(item,index){return _c('el-checkbox',{key:index,attrs:{"label":item.no,"true-label":""}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }